






import Class from './chart-tone-line';
export default Class;
